import Vue from 'vue'
import store from '../store/index.js'
import Router from 'vue-router'
import * as auth from '../api/auth/index.js'
import * as restrictAccess from '../api/restrict_access/index.js'
import * as userApi from '../api/user/index.js'
import {getLocalStore, removeLocalStore} from '../store/utils/storage.js'
import { appWhitelist } from '../store/utils/app_whitelist.js'
import {authUrl, myUrl, appName} from '../../config/env.js'
const setToken = () => import('../components/auth/SetToken.vue')
const logout = () => import('../components/auth/Logout.vue')
const userAgent = () => import('../components/common/UserAgent.vue')
const app = () => import('../components/App.vue')
const top = () => import('../components/top/Top.vue')
const noticeSetting = () => import('../components/common/header/notice_setting/NoticeSetting.vue')
const person = () => import('../components/search/Person.vue')
const detail = () => import('../components/search/Detail.vue')
const personMemo = () => import('../components/search/MemoReadMore.vue')
const timeLine = () => import('../components/search/timeline/TimeLine.vue')
const profile = () => import('../components/profile/Profile.vue')
const positioning = () => import('../components/positioning/Positioning.vue')
const wholeData = () => import('../components/positioning/whole/WholeData.vue')
const interviewRegister = () => import('../components/interview/register/Register.vue')
const interviewList = () => import('../components/interview/list/InterviewList.vue')
const interviewContent = () => import('../components/interview/list/ContentView.vue')
const interviewRecordList = () => import('../components/interview/record/InterviewRecord.vue')
const interviewRecordContent = () => import('../components/interview/record/InterviewRecordContent.vue')
const advanceConfirm = () => import('../components/advance_confirm/register/AdvanceConfirm.vue')
const advanceConfirmDetail = () => import('../components/advance_confirm/register/Detail.vue')
const advanceConfirmEdit = () => import('../components/advance_confirm/register/Edit.vue')
const advanceConfirmAnser = () => import('../components/advance_confirm/answer/AdvanceConfirmAnswer.vue')
const transitive = () => import('../components/workers_transitive/Transitive.vue')
const area = () => import('../components/master/area/Area.vue')
const areaDetail = () => import('../components/master/area/Detail.vue')
const jobCategory = () => import('../components/master/job_category/JobCategory.vue')
const jobCategoryEdit = () => import('../components/master/job_category/Edit.vue')
const jobOffer = () => import('../components/master/job_offer/JobOffer.vue')
const jobMediaEdit = () => import('../components/master/job_offer/job_media/JobMediaEdit.vue')
const hrIntroductionEdit = () => import('../components/master/job_offer/hr_introduction/HRIntroductionEdit.vue')
const schoolIntroductionEdit = () => import('../components/master/job_offer/school_introduction/SchoolIntroductionEdit.vue')
const office = () => import('../components/master/office/Office.vue')
const officeDetail = () => import('../components/master/office/Detail.vue')
const post = () => import('../components/master/post/Post.vue')
const postDetail = () => import('../components/master/post/Detail.vue')
const division = () => import('../components/master/division/Division.vue')
const divisionDetail = () => import('../components/master/division/Detail.vue')
const user = () => import('../components/master/user/User.vue')
const userDetail = () => import('../components/master/user/UserDetail.vue')
const userEdit = () => import('../components/master/user/UserEdit.vue')
const workerDetailItem = () => import('../components/master/worker_detail_item/WorkerDetailItem.vue')
const workerDetailItemEdit = () => import('../components/master/worker_detail_item/Edit.vue')
const authType = () => import('../components/master/auth_type/AuthType.vue')
const authTypeEdit = () => import('../components/master/auth_type/Edit.vue')
const authAllocation = () => import('../components/master/auth_allocation/AuthAllocation.vue')
const authAllocationEdit = () => import('../components/master/auth_allocation/Edit.vue')
const createAuth = () => import('../components/management/create_auth/CreateAuth.vue')
const publicRecruitment = () => import('../components/public_recruitment/register/PublicRecruitment.vue')
const publicRecruitmentRegister = () => import('../components/public_recruitment/register/Register.vue')
const publicRecruitmentApplication = () => import('../components/public_recruitment/application/ApplicationForm.vue')
const publicRecruitmentSearch = () => import('../components/public_recruitment/search/PublicRecruitment.vue')
const publicRecruitmentDetail = () => import('../components/public_recruitment/search/Detail.vue')
const publicRecruitmentRecordList = () => import('../components/public_recruitment/record/PublicRecruitmentRecord.vue')
const publicRecruitmentRecordContent = () => import('../components/public_recruitment/record/RecordContent.vue')
const publicRecruitmentAdvanceConfirm = () => import('../components/public_recruitment/advance_confirm/AdvanceConfirmAnswer.vue')
const publicRecruitmentCategory = () => import('../components/master/public_recruitment_category/PublicRecruitmentCategory.vue')
const publicRecruitmentCategoryEdit = () => import('../components/master/public_recruitment_category/PublicRecruitmentCategoryEdit.vue')
const publicRecruitmentSheet = () => import('../components/public_recruitment/search/sheet/Sheet.vue')
const retirePlanRegister = () => import('../components/retire_plan/register/Register.vue')
const retirePlanList = () => import('../components/retire_plan/list/RetirePlanSearch.vue')
const retirePlanDetail = () => import('../components/retire_plan/detail/RetirePlanDetail.vue')
const fixDataRegister = () => import('../components/fix_data_register/FixDataRegister.vue')
const workersArragement = () => import('../components/workers_arrangement/WorkersArrangement.vue')
const employStatusGroup = () => import('../components/master/employ_status_group/EmployStatusGroup.vue')
const employStatusGroupEdit = () => import('../components/master/employ_status_group/EmployStatusGroupEdit.vue')
const rewardAndPunishmentItem = () => import('../components/master/reward_and_punishment_item/RewardAndPunishmentItem.vue')
const rewardAndPunishmentItemEdit = () => import('../components/master/reward_and_punishment_item/Edit.vue')
const rewardAndPunishmentCategoryEdit = () => import('../components/master/reward_and_punishment_item/CategoryEdit.vue')
const rewardAndPunishmentRegister = () => import('../components/reward_and_punishment/register/Register.vue')
const rewardAndPunishmentSearch = () => import('../components/reward_and_punishment/search/Search.vue')
const rewardAndPunishmentDetail = () => import('../components/reward_and_punishment/detail/Detail.vue')
const segment = () => import('../components/master/segment/Segment.vue')
const segmentEdit = () => import('../components/master/segment/SegmentEdit.vue')
const boardOfDirectorsDocument = () => import('../components/board_of_directors_document/Search.vue')
const dept = () => import('../components/master/dept/Dept.vue')
const deptDetail = () => import('../components/master/dept/Detail.vue')
const recruitDiv = () => import('../components/master/recruit_div/RecruitDiv.vue')
const transferHopeRegister = () => import('../components/transfer_hope/register/Register.vue')
const transferHopeSearch = () => import('../components/transfer_hope/search/Search.vue')
const transferHopeDetail = () => import('../components/transfer_hope/detail/Detail.vue')
const transferHopeRecordList = () => import('../components/transfer_hope/record/List.vue')
const transferHopeRecordContent = () => import('../components/transfer_hope/record/Content.vue')
const transferPossible = () => import('../components/master/transfer_possible/TransferPossible.vue')
const transferPossibleEdit = () => import('../components/master/transfer_possible/Edit.vue')
const group = () => import('../components/master/group/search/Search.vue')
const groupDetail = () => import('../components/master/group/detail/Detail.vue')
const groupEdit = () => import('../components/master/group/detail/Edit.vue')
const absentWithoutRegister = () => import('../components/absent_without/register/Register.vue')
const absentWithoutSearch = () => import('../components/absent_without/search/Search.vue')
const absentWithoutDetail = () => import('../components/absent_without/detail/Detail.vue')
const minutesRegister = () => import('../components/minutes/register/Register.vue')
const minutesSearch = () => import('../components/minutes/search/Search.vue')
const minutesDetail = () => import('../components/minutes/detail/Detail.vue')
const minutesEdit = () => import('../components/minutes/detail/basic_info/Edit.vue')
const minutesAgendaRegister = () => import('../components/minutes/detail/agenda/agenda_register/Register.vue')
const minutesAgendaDetail = () => import('../components/minutes/detail/agenda/agenda_detail/Detail.vue')
const retireeManagementSearch = () => import('../components/retiree_management/search/Search.vue')
const retireeManagementDetail = () => import('../components/retiree_management/detail/Detail.vue')
const transferPlanDeadline = () => import('../components/master/transfer_plan_deadline/TransferPlanDeadline.vue')
const transferPlanDeadlineEdit = () => import('../components/master/transfer_plan_deadline/Edit.vue')
const transferPlanRegister = () => import('../components/transfer_plan/register/Register.vue')
const transferPlanSearch = () => import('../components/transfer_plan/search/list/Search.vue')
const transferPlanDetail = () => import('../components/transfer_plan/search/detail/Detail.vue')
const transferPlanApprovalSearch = () => import('../components/transfer_plan/approval/list/Search.vue')
const transferPlanApprovalDetail = () => import('../components/transfer_plan/approval/detail/Detail.vue')
const transferManagementSearch = () => import('../components/transfer_management/search/list/Search.vue')
const transferManagementDetail = () => import('../components/transfer_management/search/detail/Detail.vue')
const leaveOfAbsenceRegister = () => import('../components/leave_of_absence/register/Register.vue')
const leaveOfAbsenceSearch = () => import('../components/leave_of_absence/search/Search.vue')
const leaveOfAbsenceDetail = () => import('../components/leave_of_absence/detail/Detail.vue')
const leaveOfAbsenceConfirm = () => import('../components/leave_of_absence/confirm/Confirm.vue')
// Nlog廃止に伴ってコメントアウト 2024/08/22 赤坂
// const resultManagementRegister = () => import('../components/result_management/register/Register.vue')
// const resultManagementSearch = () => import('../components/result_management/search/Search.vue')
// const resultManagementDetail = () => import('../components/result_management/detail/Detail.vue')
// const resultManagementRecordList = () => import('../components/result_management/record/List.vue')
// const resultManagementRecordContent = () => import('../components/result_management/record/Content.vue')

Vue.use(Router)

var router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/setToken/:shainNo/:tokenId',
      name: 'setToken',
      component: setToken,
      meta: { requireAuth: false }
    },
    {
      path: '/unsupported',
      name: 'unsupported',
      component: userAgent,
      meta: { requireAuth: false }
    },
    {
      path: '/',
      component: app,
      redirect: 'top',
      children: [
        {
          path: '/logout',
          name: 'logout',
          component: logout,
          meta: {
            requireAuth: true,
            menu: 0
          }
        },
        {
          path: 'top',
          component: top,
          meta: {
            requireAuth: true,
            menu: 0
          }
        },
        {
          path: 'profile',
          component: profile,
          meta: {
            requireAuth: true,
            menu: 901
          }
        },
        {
          path: 'noticeSetting',
          component: noticeSetting,
          meta: {
            requireAuth: true,
            menu: 904
          }
        },
        {
          path: 'search/person',
          component: person,
          meta: {
            requireAuth: true,
            menu: 101
          }
        },
        {
          path: 'search/:worker_detail_id_digest',
          component: detail,
          meta: {
            requireAuth: true,
            menu: 101
          }
        },
        {
          path: 'search/memo/:worker_detail_id_digest',
          component: personMemo,
          meta: {
            requireAuth: true,
            menu: 101
          }
        },
        {
          path: 'search/timeLine/:shain_no_digest',
          component: timeLine,
          meta: {
            requireAuth: true,
            menu: 101
          }
        },
        {
          path: 'positioning',
          component: positioning,
          meta: {
            requireAuth: true,
            menu: 201
          }
        },
        {
          path: 'publicRecruitment/search',
          component: publicRecruitmentSearch,
          meta: {
            requireAuth: true,
            menu: 104
          }
        },
        {
          path: 'publicRecruitment/search/:hash',
          component: publicRecruitmentDetail,
          meta: {
            requireAuth: true,
            menu: 104
          }
        },
        {
          path: 'publicRecruitmentSheet/:hash',
          component: publicRecruitmentSheet,
          meta: {
            requireAuth: true,
            menu: 104
          }
        },
        {
          path: 'positioning/wholeData',
          component: wholeData,
          meta: {
            requireAuth: true,
            menu: 201
          }
        },
        {
          path: 'interview/register',
          component: interviewRegister,
          meta: {
            requireAuth: true,
            menu: 301
          }
        },
        {
          path: 'interview/list',
          component: interviewList,
          meta: {
            requireAuth: true,
            menu: 102
          }
        },
        {
          path: 'interview/content/:hash',
          component: interviewContent,
          meta: {
            requireAuth: true,
            menu: 102
          }
        },
        {
          path: 'interviewRecord/list',
          component: interviewRecordList,
          meta: {
            requireAuth: true,
            menu: 902
          }
        },
        {
          path: 'interviewRecord/:hash',
          component: interviewRecordContent,
          meta: {
            requireAuth: true,
            menu: 902
          }
        },
        {
          path: 'advanceConfirm',
          component: advanceConfirm,
          meta: {
            requireAuth: true,
            menu: 303
          }
        },
        {
          path: 'advanceConfirmDetail/:advance_confirm_hash',
          component: advanceConfirmDetail,
          meta: {
            requireAuth: true,
            menu: 303
          }
        },
        {
          path: 'advanceConfirmEdit/:advance_confirm_hash',
          component: advanceConfirmEdit,
          meta: {
            requireAuth: true,
            menu: 303
          }
        },
        {
          path: '/advanceConfirmAnswer/:interview_id',
          component: advanceConfirmAnser,
          meta: {
            requireAuth: true,
            menu: 0
          }
        },
        {
          path: '/publicRecruitmentAdvanceConfirmAnswer/:hash',
          component: publicRecruitmentAdvanceConfirm,
          meta: {
            requireAuth: true,
            menu: 0
          }
        },
        {
          path: 'publicRecruitment',
          component: publicRecruitment,
          meta: {
            requireAuth: true,
            menu: 304
          }
        },
        {
          path: 'publicRecruitment/:hash',
          component: publicRecruitmentRegister,
          meta: {
            requireAuth: true,
            menu: 304
          }
        },
        { path: 'publicRecruitmentApplication/:hash',
          component: publicRecruitmentApplication,
          meta: {
            requireAuth: true,
            menu: 104
          }
        },
        {
          path: 'publicRecruitmentRecord/list',
          component: publicRecruitmentRecordList,
          meta: {
            requireAuth: true,
            menu: 903
          }
        },
        {
          path: 'publicRecruitmentRecord/:hash',
          component: publicRecruitmentRecordContent,
          meta: {
            requireAuth: true,
            menu: 903
          }
        },
        {
          path: 'workers_transitive',
          component: transitive,
          meta: {
            requireAuth: true,
            menu: 202
          }
        },
        {
          path: 'area',
          component: area,
          meta: {
            requireAuth: true,
            menu: 405
          }
        },
        {
          path: 'area/:area_id_digest',
          component: areaDetail,
          meta: {
            requireAuth: true,
            menu: 405
          }
        },
        {
          path: 'jobOffer',
          component: jobOffer,
          meta: {
            requireAuth: true,
            menu: 407
          }
        },
        {
          path: 'jobMediaEdit/:job_offer_id_digest',
          component: jobMediaEdit,
          meta: {
            requireAuth: true,
            menu: 407
          }
        },
        {
          path: 'hrIntroductionEdit/:job_offer_id_digest',
          component: hrIntroductionEdit,
          meta: {
            requireAuth: true,
            menu: 407
          }
        },
        {
          path: 'schoolIntroductionEdit/:job_offer_id_digest',
          component: schoolIntroductionEdit,
          meta: {
            requireAuth: true,
            menu: 407
          }
        },
        {
          path: 'jobCategory',
          component: jobCategory,
          meta: {
            requireAuth: true,
            menu: 406
          }
        },
        {
          path: 'jobCategory/:job_id_digest',
          component: jobCategoryEdit,
          meta: {
            requireAuth: true,
            menu: 406
          }
        },
        {
          path: 'office',
          component: office,
          meta: {
            requireAuth: true,
            menu: 402
          }
        },
        {
          path: 'office/:office_id_digest',
          component: officeDetail,
          meta: {
            requireAuth: true,
            menu: 402
          }
        },
        {
          path: 'post',
          component: post,
          meta: {
            requireAuth: true,
            menu: 404
          }
        },
        /* 役職の並び順変更は権限、名称グループにも影響があるため、一旦編集不可に。
        2020/04/01 赤坂
        カラーコード設定のため、編集できるように設定変更
        2020/06/15 山本
        */
        {
          path: 'post/:post_id_digest',
          component: postDetail,
          meta: {
            requireAuth: true,
            menu: 404
          }
        },
        {
          path: 'division',
          component: division,
          meta: {
            requireAuth: true,
            menu: 403
          }
        },
        {
          path: 'division/:division_id_digest',
          component: divisionDetail,
          meta: {
            requireAuth: true,
            menu: 403
          }
        },
        {
          path: 'user',
          component: user,
          meta: {
            requireAuth: true,
            menu: 401
          }
        },
        {
          path: 'userDetail/:shain_no_digest',
          component: userDetail,
          meta: {
            requireAuth: true,
            menu: 401
          }
        },
        {
          path: 'userEdit/:shain_no_digest',
          component: userEdit,
          meta: {
            requireAuth: true,
            menu: 401
          }
        },
        {
          path: 'workerDetailItem',
          component: workerDetailItem,
          meta: {
            requireAuth: true,
            menu: 408
          }
        },
        {
          path: 'workerDetailItem/:worker_detail_item_id_digest',
          component: workerDetailItemEdit,
          meta: {
            requireAuth: true,
            menu: 408
          }
        },
        {
          path: 'authType',
          component: authType,
          meta: {
            requireAuth: true,
            menu: 409
          }
        },
        {
          path: 'authType/:auth_type_hash',
          component: authTypeEdit,
          meta: {
            requireAuth: true,
            menu: 409
          }
        },
        {
          path: 'authAllocation',
          component: authAllocation,
          meta: {
            requireAuth: true,
            menu: 410
          }
        },
        {
          path: 'authAllocation/:auth_allocation_hash',
          component: authAllocationEdit,
          meta: {
            requireAuth: true,
            menu: 410
          }
        },
        {
          path: 'publicRecruitmentCategory',
          component: publicRecruitmentCategory,
          meta: {
            requireAuth: true,
            menu: 411
          }
        },
        {
          path: 'publicRecruitmentCategoryEdit/:hash',
          component: publicRecruitmentCategoryEdit,
          meta: {
            requireAuth: true,
            menu: 411
          }
        },
        {
          path: 'segment',
          component: segment,
          meta: {
            requireAuth: true,
            menu: 412
          }
        },
        {
          path: 'segmentEdit/:hash',
          component: segmentEdit,
          meta: {
            requireAuth: true,
            menu: 412
          }
        },
        {
          path: 'employStatusGroup',
          component: employStatusGroup,
          meta: {
            requireAuth: true,
            menu: 414
          }
        },
        {
          path: 'employStatusGroupEdit',
          component: employStatusGroupEdit,
          meta: {
            requireAuth: true,
            menu: 414
          }
        },
        {
          path: 'dept',
          component: dept,
          meta: {
            requireAuth: true,
            menu: 420
          }
        },
        {
          path: 'dept/:dept_id_digest',
          component: deptDetail,
          meta: {
            requireAuth: true,
            menu: 420
          }
        },
        {
          path: 'recruit',
          component: recruitDiv,
          meta: {
            requireAuth: true,
            menu: 421
          }
        },
        {
          path: 'createAuth',
          component: createAuth,
          meta: {
            requireAuth: true,
            menu: 501
          }
        },
        {
          path: 'retirePlanRegister',
          component: retirePlanRegister,
          meta: {
            requireAuth: true,
            menu: 305
          }
        },
        {
          path: 'retirePlan/list',
          component: retirePlanList,
          meta: {
            requireAuth: true,
            menu: 105
          }
        },
        {
          path: 'retirePlan/:hash',
          component: retirePlanDetail,
          meta: {
            requireAuth: true,
            menu: 105
          }
        },
        {
          path: 'fixDataRegister',
          component: fixDataRegister,
          meta: {
            requireAuth: true,
            menu: 306
          }
        },
        {
          path: 'workersArrangement',
          component: workersArragement,
          meta: {
            requireAuth: true,
            menu: 203
          }
        },
        {
          path: 'rewardAndPunishmentItem',
          component: rewardAndPunishmentItem,
          meta: {
            requireAuth: true,
            menu: 413
          }
        },
        {
          path: 'rewardAndPunishmentItemEdit/:hash',
          component: rewardAndPunishmentItemEdit,
          meta: {
            requireAuth: true,
            menu: 413
          }
        },
        {
          path: 'rewardAndPunishmentCategoryEdit',
          component: rewardAndPunishmentCategoryEdit,
          meta: {
            requireAuth: true,
            menu: 413
          }
        },
        {
          path: 'rewardAndPunishmentRegister',
          component: rewardAndPunishmentRegister,
          meta: {
            requireAuth: true,
            menu: 307
          }
        },
        {
          path: 'rewardAndPunishmentSearch',
          component: rewardAndPunishmentSearch,
          meta: {
            requireAuth: true,
            menu: 106
          }
        },
        {
          path: 'rewardAndPunishmentDetail/:hash',
          component: rewardAndPunishmentDetail,
          meta: {
            requireAuth: true,
            menu: 106
          }
        },
        {
          path: 'boardOfDirectorsSearch',
          component: boardOfDirectorsDocument,
          meta: {
            requireAuth: true,
            menu: 107
          }
        },
        // Nlog廃止に伴ってコメントアウト 2024/08/22 赤坂
        // {
        //   path: 'resultManagementRegister',
        //   component: resultManagementRegister,
        //   meta: {
        //     requireAuth: true,
        //     menu: 308
        //   }
        // },
        // {
        //   path: 'resultManagementSearch',
        //   component: resultManagementSearch,
        //   meta: {
        //     requireAuth: true,
        //     menu: 108
        //   }
        // },
        // {
        //   path: 'resultManagementDetail/:hash',
        //   component: resultManagementDetail,
        //   meta: {
        //     requireAuth: true,
        //     menu: 108
        //   }
        // },
        // {
        //   path: 'resultManagementRecord/list',
        //   component: resultManagementRecordList,
        //   meta: {
        //     requireAuth: true,
        //     menu: 905
        //   }
        // },
        // {
        //   path: 'resultManagementRecord/:hash',
        //   component: resultManagementRecordContent,
        //   meta: {
        //     requireAuth: true,
        //     menu: 905
        //   }
        // },
        {
          path: 'transferHopeRegister',
          component: transferHopeRegister,
          meta: {
            requireAuth: true,
            menu: 309
          }
        },
        {
          path: 'transferHopeSearch',
          component: transferHopeSearch,
          meta: {
            requireAuth: true,
            menu: 109
          }
        },
        {
          path: 'transferHopeDetail/:hash',
          component: transferHopeDetail,
          meta: {
            requireAuth: true,
            menu: 109
          }
        },
        {
          path: 'transferHopeRecord',
          component: transferHopeRecordList,
          meta: {
            requireAuth: true,
            menu: 906
          }
        },
        {
          path: 'transferHopeRecord/:hash',
          component: transferHopeRecordContent,
          meta: {
            requireAuth: true,
            menu: 906
          }
        },
        {
          path: 'transferPossible',
          component: transferPossible,
          meta: {
            requireAuth: true,
            menu: 417
          }
        },
        {
          path: 'transferPossibleEdit/:hash',
          component: transferPossibleEdit,
          meta: {
            requireAuth: true,
            menu: 417
          }
        },
        {
          path: '/group',
          component: group,
          meta: {
            requireAuth: true,
            menu: 418
          }
        },
        {
          path: '/groupDetail/:hash',
          component: groupDetail,
          meta: {
            requireAuth: true,
            menu: 418
          }
        },
        {
          path: '/groupEdit/:hash',
          component: groupEdit,
          meta: {
            requireAuth: true,
            menu: 418
          }
        },
        {
          path: '/absentWithoutRegister',
          component: absentWithoutRegister,
          meta: {
            requireAuth: true,
            menu: 310
          }
        },
        {
          path: '/absentWithoutSearch',
          component: absentWithoutSearch,
          meta: {
            requireAuth: true,
            menu: 110
          }
        },
        {
          path: '/absentWithout/:hash',
          component: absentWithoutDetail,
          meta: {
            requireAuth: true,
            menu: 110
          }
        },
        {
          path: '/minutesRegister',
          component: minutesRegister,
          meta: {
            requireAuth: true,
            menu: 311
          }
        },
        {
          path: '/minutesSearch',
          component: minutesSearch,
          meta: {
            requireAuth: true,
            menu: 111
          }
        },
        {
          path: '/minutesDetail/:hash',
          component: minutesDetail,
          meta: {
            requireAuth: true,
            menu: 111
          }
        },
        {
          path: '/minutesEdit/:hash',
          component: minutesEdit,
          meta: {
            requireAuth: true,
            menu: 111
          }
        },
        {
          path: '/minutesAgendaRegister/:minutesHash',
          component: minutesAgendaRegister,
          meta: {
            requireAuth: true,
            menu: 111
          }
        },
        {
          path: '/minutesAgendaDetail/:agendaHash',
          component: minutesAgendaDetail,
          meta: {
            requireAuth: true,
            menu: 111
          }
        },
        {
          path: '/retireeManagement/search',
          component: retireeManagementSearch,
          meta: {
            requireAuth: true,
            menu: 112
          }
        },
        {
          path: '/retireeManagement/:hash',
          component: retireeManagementDetail,
          meta: {
            requireAuth: true,
            menu: 112
          }
        },
        {
          path: '/transferPlanDeadline',
          component: transferPlanDeadline,
          meta: {
            requireAuth: true,
            menu: 419
          }
        },
        {
          path: '/transferPlanDeadline/edit/:targetYear',
          component: transferPlanDeadlineEdit,
          meta: {
            requireAuth: true,
            menu: 419
          }
        },
        {
          path: 'transferPlanRegister',
          component: transferPlanRegister,
          meta: {
            requireAuth: true,
            menu: 312
          }
        },
        {
          path: 'transferPlan/search',
          component: transferPlanSearch,
          meta: {
            requireAuth: true,
            menu: 113
          }
        },
        {
          path: 'transferPlan/:hash',
          component: transferPlanDetail,
          meta: {
            requireAuth: true,
            menu: 113
          }
        },
        {
          path: 'transferPlan/approval/search',
          component: transferPlanApprovalSearch,
          meta: {
            requireAuth: true,
            menu: 601
          }
        },
        {
          path: 'transferPlan/approval/:hash',
          component: transferPlanApprovalDetail,
          meta: {
            requireAuth: true,
            menu: 601
          }
        },
        {
          path: 'transferManagement/search',
          component: transferManagementSearch,
          meta: {
            requireAuth: true,
            menu: 114
          }
        },
        {
          path: 'transferManagement/:year/:month',
          component: transferManagementDetail,
          meta: {
            requireAuth: true,
            menu: 114
          }
        },
        {
          path: '/leaveOfAbsence/register',
          component: leaveOfAbsenceRegister,
          meta: {
            requireAuth: true,
            menu: 313
          }
        },
        {
          path: '/leaveOfAbsence/search',
          component: leaveOfAbsenceSearch,
          meta: {
            requireAuth: true,
            menu: 115
          }
        },
        {
          path: '/leaveOfAbsence/:hash',
          component: leaveOfAbsenceDetail,
          meta: {
            requireAuth: true,
            menu: 115
          }
        },
        {
          path: '/leaveOfAbsence/confirm/:hash',
          component: leaveOfAbsenceConfirm,
          meta: {
            requireAuth: true,
            menu: 115
          }
        }
      ]
    },
    {
      path: '*',
      redirect: 'top'
    }
  ]
})

// ログイン認証はここで行う
router.beforeEach((to, from, next) => {
  let userAgent = window.navigator.userAgent.toLowerCase()

  // アプリの起動
  appOpen(userAgent)

  // 非対応ブラウザ判定
  if (!unsupported(to, next, userAgent)) {
    return
  }

  // アプリ利用可能画面判定
  if (!appWhitelistCheck(to, next, userAgent)) {
    return
  }

  // 権限チェック不要ページは次の処理へ
  if (!to.meta.requireAuth) {
    next()
    return
  }

  // フロント権限確認
  frontAuthCheck(to.meta.menu, next)

  restrictAccess.CheckIp(to.path)
    .then((r) => {
      store.commit('forbidden', false)
      store.commit('onLoading', true)
      store.dispatch('transition/MENU', to.meta.menu)
      let accessToken = getLocalStore('ACCESS_TOKEN')
      let refreshToken = getLocalStore('REFRESH_TOKEN')
      let shainNo = getLocalStore('SHAIN_NO')
      if (shainNo && accessToken && refreshToken) {
        auth.checkAccessToken(shainNo, accessToken)
          .then((res) => {
            // store.dispatch('auth/SHAIN_NAME', 'てらしましょうへい')
            dispatchShainName(shainNo, ['ShainName'])
            next()
          }).catch((res) => {
            let refreshToken = getLocalStore('REFRESH_TOKEN')
            auth.checkRefreshToken(shainNo, refreshToken)
              .then((r) => {
                dispatchShainName(shainNo, ['ShainName'])
                next()
              }).catch((r) => {
                resetRedirect()
              })
          })
      } else {
        resetRedirect()
      }
    })
    .catch((e) => {
      console.log(e)
      store.commit('forbidden', true)
      next()
    })
})

function dispatchShainName (shainNo, name) {
  if (!store.state.auth.shainName) {
    userApi.getShainInfo(shainNo, name)
      .then((r) => {
        store.dispatch('auth/SHAIN_NAME', r.data.ShainName)
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

function resetRedirect () {
  removeLocalStore('ACCESS_TOKEN')
  removeLocalStore('REFRESH_TOKEN')
  removeLocalStore('SHAIN_NO')
  removeLocalStore('AUTH_LIST')
  store.dispatch('auth/SHAIN_NAME', '')
  let pathname = location.pathname
  location.href = authUrl + '/login?' +
  'url=' + myUrl + '/setToken' + '&transition=' + pathname
}

function appOpen (userAgent) {
  if (userAgent.indexOf('hitologapp') === -1) {
    let target = ['iphone', 'android', 'ipad', 'ipod']
    let len = target.length
    for (let i = 0; i < len; ++i) {
      if (userAgent.indexOf(target[i]) > -1) {
        let host = location.hostname
        let path = location.pathname
        let parameter = '?host=' + host + '&path=' + path
        location.href = 'appname://' + appName + parameter
        break
      }
    }
  }
}

function unsupported (to, next, userAgent) {
  let res = true
  if (userAgent.indexOf('msie') > -1 || userAgent.indexOf('trident') > -1) {
    if (to.path !== '/unsupported') {
      res = false
      next({ path: '/unsupported' })
    }
  }
  return res
}

function appWhitelistCheck (to, next, userAgent) {
  if (userAgent.indexOf('hitologapp') === -1 || to.path === '/top') {
    return true
  }
  let res = false
  let split = to.path.split('/')
  let splitLen = split.length
  let x = appWhitelist.length
  for (let a = 0; a < x; ++a) {
    let y = appWhitelist[a].length
    for (let b = 0; b < y; ++b) {
      if (b <= splitLen && split[b + 1] === appWhitelist[a][b]) {
        if (b - 0 === y - 1) {
          res = true
          break
        }
      } else {
        break
      }
    }
    if (res) break
  }
  if (!res) next({ path: '/top' })
  return res
}

function frontAuthCheck (menu, next) {
  let noCheck = [0, 901, 902, 903, 904, 905, 906]
  for (let i = 0; i < noCheck.length; ++i) {
    if (noCheck[i] === menu) return
  }
  let authList = getLocalStore('AUTH_LIST')
  if (authList !== null && authList.indexOf(menu) < 0) {
    next({ path: '/top' })
  }
}

router.afterEach((to, from) => {
  store.commit('onLoading', false)
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js